import React from "react";
import { CategoryPost
        ,CategoryPostDescriptionImage
        ,CategoryPostDescription
        ,CategoryPostTitle
        ,CategoryExcerpt
        ,sPostLanguage
        ,sGoto
        ,sPostTitleLink 
       } from '../theme/globalStyle'
import { Link } from 'gatsby'
import { FormattedMessage } from "react-intl";
const _ = require('lodash');

//const imagenPortada = 'https://via.placeholder.com/100x100';  

const CategoryDescription = props => (
        <CategoryPost>
            <CategoryPostDescriptionImage src={props.image} />
            <CategoryPostDescription>
                <CategoryPostTitle>
                    {props.langKey && (
                            <Link css={sPostLanguage} to={`${props.langKey}`}>{props.langKey}</Link>
                        )
                    }
                    <Link css={sPostTitleLink} to={`${props.langKey}/${_.kebabCase(props.titlepost)}`}>{props.titlepost}</Link>
                </CategoryPostTitle>
                <CategoryExcerpt>
                    {props.excerpt}
                    <br />
                    {props.podcast && (
                            <Link css={sGoto} to={`${props.langKey}/${props.slug}`}><FormattedMessage id="see-podcast" /></Link>
                        )
                    }

                    {!props.podcast && (
                            <Link css={sGoto} to={`${props.langKey}/${props.slug}`}><FormattedMessage id="see-category" /></Link>
                        )
                    }
                </CategoryExcerpt>
            </CategoryPostDescription>
        </CategoryPost>
)

export default CategoryDescription